import { Injectable } from '@angular/core';
import {
  CartItem,
  EndOrderDetails,
  CouponConfigurationResponse,
  EstablishmentCheckout,
  EMPTY_PAYMENT_LINK,
} from '@pedix-workspace/utils';
import { ShippingCostResponse } from '@pedix-workspace/shared-delivery';
import { EndOrderForm } from './end-order-form/end-order-form.service';
import { EndOrderTotals } from './end-order-totals.service';
import { customFieldValuesToCustomFieldDetails } from '@pedix-workspace/orders';

export type NewEndOrderDetailsParams = {
  cartItems: CartItem[];
  establishmentId: string;
  couponConfigurationSnapshot?: CouponConfigurationResponse;
  shippingCostResponse?: ShippingCostResponse;
  endOrderForm: EndOrderForm;
  endOrderTotals: EndOrderTotals;
  checkoutData: EstablishmentCheckout;
  source: EndOrderDetails['source'];
  userUid?: string;
  copiedFrom?: string;
};

@Injectable({
  providedIn: 'root',
})
export class EndOrderService {
  createEndOrderDetails({
    cartItems,
    establishmentId,
    couponConfigurationSnapshot,
    shippingCostResponse,
    endOrderTotals,
    endOrderForm,
    checkoutData,
    source,
    userUid,
    copiedFrom,
  }: NewEndOrderDetailsParams): EndOrderDetails {
    return {
      created: new Date(),
      updated: new Date(),
      status: 'new',
      sequenceId: 0,
      establishmentId,
      cartItems,
      paymentLink: endOrderForm.paymentMethod?.hasLink ? EMPTY_PAYMENT_LINK : null,
      tags: [],
      schemaVersion: 7,
      source,
      copiedFrom,
      personalInformation: {
        name: endOrderForm.name,
        phone: endOrderForm.phone,
        email: endOrderForm.email,
        address: endOrderForm.address,
      },
      billingInformation: endOrderForm.requestBilling ? endOrderForm.billingInformation : null,
      totalAmount: endOrderTotals.totalAmount,
      totalAmountWithDiscount: endOrderTotals.totalAmountWithDiscount,
      totalProductDiscount: endOrderTotals.totalProductDiscount,
      deliveryCost: endOrderTotals.deliveryCost,
      couponDiscount: endOrderTotals.couponDiscount,
      paymentMethodExtraCharge: endOrderTotals.paymentMethodExtraCharge,
      paymentMethodDiscount: endOrderTotals.paymentMethodDiscount,
      finalAmount: endOrderTotals.finalAmount,
      couponConfigurationSnapshot: couponConfigurationSnapshot,
      customFieldDetails: customFieldValuesToCustomFieldDetails(
        checkoutData.customFields,
        endOrderForm.customFieldDetailValues || [],
      ),
      outOfDeliveryZone: shippingCostResponse?.outOfDeliveryZone || false,
      paymentMethod: endOrderForm.paymentMethod,
      shippingOption: endOrderForm.shippingOption,
      tableNumber: endOrderForm.tableNumber,
      howMuch: endOrderForm.howMuch,
      shippingEstimate: shippingCostResponse?.shippingEstimate,
      userUid,
      currencyCode: endOrderTotals.currencyCode,
      // Food Bank Donation
      foodBankDonationAmount: endOrderTotals.foodBankDonationAmount,
    };
  }
}
